import React from 'react';

import { OnboardingStepTitle } from '../../../../components';
import { ControlledTagAutocomplete } from '../../../../components/controlled-inputs';

type Props = {
  staff: {
    uuid: string;
    name: string;
  }[];
  setSubstring: (substring: string) => void;
};
export const AddLocationManagersStep = ({ staff, setSubstring }: Props) => {
  return (
    <>
      <OnboardingStepTitle text="Would you like to assign any Managers to this Location?" />

      <ControlledTagAutocomplete
        name="locationManagers"
        margin="none"
        items={staff}
        label="Location Managers"
        setSubstring={setSubstring}
        multiple
      />
    </>
  );
};
